import { render, staticRenderFns } from "./ShiftStore.vue?vue&type=template&id=2197a7f0&"
import script from "./ShiftStore.vue?vue&type=script&lang=js&"
export * from "./ShiftStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports